import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FaCaretDown } from "react-icons/fa";
import { setKpiData } from "../../core/redux/filters/filter.action.jsx";

const KpisFilter = () => {
  const translation = useSelector(state => state.root.translation);
  let { listKpis2, filter } = useSelector((state) => state.filter);
  
  if(!listKpis2)
  {listKpis2 = ['sls']}
  const [selectedKpis, setSelectedKpis] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { kpisSelected } = filter;

  const dispatch = useDispatch();

  const handleCheckboxChange = (name) => {
    setSelectedKpis((prevselectedKpis) =>
      prevselectedKpis.includes(name)
        ? prevselectedKpis.filter((key) => key !== name)
        : [...prevselectedKpis, name]
    );
  };

  const handleSelectAllChange = () => {
    if (selectedKpis.length === listKpis2.length) {
      setSelectedKpis([]);
    } else {
      setSelectedKpis(listKpis2);
    }
  };
  const showDropDown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setSelectedKpis(kpisSelected);
  }, [kpisSelected]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
  }, []);

  const submit = () => {
    console.log('selectedKpis',selectedKpis);
    dispatch(setKpiData({ kpisSelected: selectedKpis }));
    setIsOpen(false);
  };

  const cancel = () => {
    setSelectedKpis(kpisSelected); 
    setIsOpen(false);
  };
  

  return (
    <div ref={dropdownRef} className=" dropdown select-store-dropdown">
      <div
        className="dropdown-toggle nav-link select-store"
        onClick={showDropDown}
      >
        <span className="user-name">
          <i className="fas fa-calendar-alt"></i> {translation['kpis']}{" "}
          {`(${selectedKpis?.length})`} <FaCaretDown />
        </span>
      </div>
      <div
        className={
          "dropdown-menu dropdown-menu-right" + (isOpen ? " show" : "")
        }
        style={{ maxHeight: "200px", overflowY: "auto" }}
      >
        <div className="dropdown-item custom-label">
          <label className="d-flex align-items-center">
            <input
              type="checkbox"
              checked={selectedKpis.length === listKpis2.length}
              onChange={handleSelectAllChange}
              className="me-2"
            />
            {translation['All']}
          </label>
        </div>
        {listKpis2?.map((name) => (
          <div key={name} className="dropdown-item custom-label">
            <label className="d-flex align-items-center">
              <input
                type="checkbox"
                checked={selectedKpis.includes(name)}
                onChange={() => handleCheckboxChange(name)}
                className="me-2"
              />
              {translation[name]}
            </label>
          </div>
        ))}
        <div className="d-flex justify-content-center button-container">
          <button
            className="btn btn-primary-light m-2"
            onClick={cancel}
          >
           {translation['cancel']}
          </button>
          <button
            className="btn btn-primary m-2"
            disabled={!selectedKpis.length}
            onClick={submit}
          >
           {translation['apply']}
          </button>
        </div>
      </div>
    </div>
  );
};

export default KpisFilter;
